import { type FeatureContext, isFeatureEnabled } from '@/feature/feature';

import { getAppConfig } from '@/utils/window.utils';

export const isDocuSignEnabled = (context: FeatureContext = {}): boolean => {
    const config = getAppConfig();
    return isFeatureEnabled(config.feature.docusign, context);
};
